import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=template&id=32d15182&lang=html"
import script from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=style&index=0&id=32d15182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports